import create from 'zustand'
import { persist } from 'zustand/middleware'
import { ActivatedClinicStore } from './types'
import { ClinicV2 } from '@/services/ActivationService/types'

export const useActivatedClinicStore = create<ActivatedClinicStore>()(
  persist(
    set => {
      return {
        clinics: [],
        setClinics: (clinics: ClinicV2[]) => {
          set({ clinics: clinics })
        },
        selectedClinic: null,
        setSelectedClinic: (clinic: ClinicV2) => {
          set({ selectedClinic: clinic })
        },
      }
    },
    {
      name: 'clinics',
      getStorage: () => sessionStorage,
    },
  ),
)
